jQuery(document).ready(function($){

	// Add spans to Inter-title with .inter-title class
	$('.inter-title').not('span').wrapInner('<span></span>');
});